// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import EntitySelectorDTO from './EntitySelectorDTO';

interface AdminOtcPenaltyDTO extends EntitySelectorDTO { 
  penaltyId: string | null;
  penaltyAmount: number | null;
  penaltyPaidDate: moment.Moment | string | null;
  penaltyIssuedDate: moment.Moment | string | null;
  penaltyDueDate: moment.Moment | string | null;
  waivedDate: moment.Moment | string | null;
  waiverRequested: boolean;
  contributionId: string | null;
  penaltyDescription: string | null;
  waiverAmount: number | null;
  penaltyWaiverReason: string | null;
  waiverDenied: boolean | null;
}
const AdminOtcPenaltyDTO = {
  create: (initValues?: Partial<AdminOtcPenaltyDTO> | Record<string, unknown> | null) => {
    return Object.assign(EntitySelectorDTO.create(),
    {
      penaltyId: "00000000-0000-0000-0000-000000000000",
      penaltyAmount: null,
      penaltyPaidDate: null,
      penaltyIssuedDate: null,
      penaltyDueDate: null,
      waivedDate: null,
      waiverRequested: false,
      contributionId: "00000000-0000-0000-0000-000000000000",
      penaltyDescription: null,
      waiverAmount: null,
      penaltyWaiverReason: null,
      waiverDenied: null,
    },
    initValues);
  }
};

export default AdminOtcPenaltyDTO;